import { serviceTypeService } from '../../../services/ServiceTypesService';
import { setServiceTypes, setServiceTypesError, setLoading } from './ServiceTypeListSlice';

export const getServiceTypes = (pageSize, pageIndex) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        dispatch(setServiceTypesError(null));
        const serviceTypesResponse = await serviceTypeService.getServiceTypes(pageSize, pageIndex);
        dispatch(setServiceTypes(serviceTypesResponse));
    } catch (err) {
        dispatch(setServiceTypesError(err));
    } finally {
        dispatch(setLoading(false));
    }
}